import "./frontend.scss"
import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter as Router } from 'react-router-dom'
import TableLoader from "@fast-simon/pricing-table/dist/components/TableLoader/TableLoader";

const divsToUpdate = document.querySelectorAll(".pricing-placeholder");

divsToUpdate.forEach(div => {
    const data = JSON.parse(div.querySelector("pre").innerText);
    ReactDOM.render(<OurComponent {...data} />, div);
    div.classList.remove("pricing-placeholder")
    div.classList.add("pricing-table-block");
});

function OurComponent(props) {
  return (
    <div className="frontend-container">
      <Router>
          <TableLoader platform={props.platform}
                         locationType="external"
                         dashboardVersion={''}
                         isDev={false}
                         siteKey={''}/>
      </Router>
    </div>
  )
}
